export default "__VITE_ASSET__UlRDUh_8__"